export const ActivationCodeNS = "ActivationCode"
export const AlertNS = "Alert"
export const CguNS = "cgu"
export const CongratsNS = "Congratulation"
export const DeleteAccountNS = "deleteAccount"
export const EvaluationNS = "Evaluation"
export const ExerciseNS = "Exercise"
export const ExercisesListNS = "ExercisesList"
export const FaqNS = "Faq"
export const HomeNS = "Home"
export const JourneyNS = "Journey"
export const LanguageNS = "Language"
export const MainNS = "Main"
export const LoginNS = "Login"
export const RegisterNS = "Register"
export const RegisterActivationCodeNS = "RegisterActivationCode"
export const RegisterPecanWorkflowExplanationNS = "RegisterPecanWorkflowExplanation"
export const RegisterPracticianWorkflowNS = "RegisterPracticianWorkflow"
export const RegisterCodeAlreadyUsedNS = "RegisterCodeAlreadyUsed"
export const RegisterVerifyIdentityNS = "RegisterVerifyIdentity"
export const RegisterVerifyIdentitySuccessNS = "RegisterVerifyIdentitySuccess"
export const RegisterCguNS = "RegisterCgu"
export const NavigationNS = "Navigation"
export const OperationNS = "Operation"
export const PatientNS = "Patient"
export const PatientsListNS = "PatientsList"
export const PracticianListNS = "PatientsList"
export const PractitionerHomeNS = "PractitionerHome"
export const PraticienNS = "Praticien"
export const ProfileNS = "Profile"
export const PasswordModificationNS = "PasswordModification"
export const ProtocolNS = "Protocol"
export const PromsNS = "Proms"
export const SettingsNS = "Settings"
export const SMSValidationNS = "SMSValidation"
export const protocolEnd = "protocolEnd"
export const VideoNS = "Video"
export const LinkPasswordProviderNS = "LinkPasswordProvider"
export const MigrationFinalizedNS = "MigrationFinalized"
export const NeedEmailVerifiedNS = "NeedEmailVerified"
export const NewClientOnboardingNS = "NewClientOnboarding"
